import countryService from '../../../services/country-service';


// 照片要求
const getPhotoTipsArr = function (product) {
  if (!product.id_photo) return [];
  const { color, height, width } = product.id_photo;
  const colorName = ['蓝', '白', '红', '灰'][color];
  const arr = [
    `${colorName}底，${width}×${height}mm`,
    '拍摄时注意光线均匀，不要佩戴眼镜，露出双耳',
    '请用纯色墙做背景，避免衣服与背景色相同',
    '手机拍摄的照片会经过程序检测并自动处理，请申请方提交订单前仔细检查照片是否为满足上述条件',
  ];

  return arr;
};

const applicationAttention = [
  '申请表支持在小程序内在线填写，系统会自动填充护照、身份证等相关信息，为您节省办理时间',
  'PS：若您选择填写纸质版表格，请在我们的系统中下载表格模板，打印并填写完毕后与其他纸质资料一同邮寄',
];


// 生成资料list，主要就是把照片，申请表，所有资料都合到一起
export const generateMaterialList = function (product, identity_id, is_offline) {
  if (!product.visa_product_id) return [];
  // 筛选是否是线下
  const allMaterialList = is_offline ? product.offline_material : product.material;
  // 筛选当前身份
  const currIdentityMaterial = allMaterialList.find(item => item.identity_id === identity_id);
  if (!currIdentityMaterial) return [];
  const materialRequired = currIdentityMaterial.material_required.map(item => ({ ...item, is_required: true }));
  const materialOptional = currIdentityMaterial.material_optional.map(item => ({ ...item, is_optional: true }));
  const photoMaterial = [];

  // 添加照片
  if (product.visa_photo_id && !is_offline) {
    photoMaterial.push({
      is_required: true,
      elec_name: '照片',
      attention: getPhotoTipsArr(product).join('\n'),
      attr: 0,
      catalog_id: 2,
      sample: product.id_photo.sample,
      template: product.id_photo.template,
    });
  }

  // 添加申请表
  const applicationMaterial = [];
  if (product.visa_application && !is_offline) {
    let attention = applicationAttention.join('\n');
    if (product.proprietary >= 1 && product.visa_country_id === countryService.getCountryId('cambodia')) {
      // 柬埔寨自营审核
      attention = applicationAttention[0];
    }
    applicationMaterial.push({
      is_required: true,
      elec_name: '签证申请表',
      attention,
      attr: 0,
      catalog_id: 2,
      sample: product.visa_application.sample,
      template: product.visa_application.template,
      visa_application_id: product.visa_application.visa_application_id,
    });
  }
  const list = [...photoMaterial, ...applicationMaterial, ...materialRequired, ...materialOptional];
  // 添加资料的icon
  list.forEach((item) => {
    const name = item.elec_name || item.paper_name || item.take_along_name;
    item.name = name;
  });
  return list;
};


// // 线下办理需要携带线上办理的赴馆资料内容
// export const generateAllMaterialList = function (product, identity_id, is_offline) {
//   // 如果为线上办理直接返回
//   if (!is_offline) {
//     return generateMaterialList(product, identity_id, is_offline);

//   }

//   // 获取线上办理的赴馆资料
//   const onlineMaterialList = generateMaterialList(product, identity_id, !is_offline);
//   const onlineTakeMaterialList = onlineMaterialList.filter(item => item.attr === 2);

//   const offlineMaterialList = generateMaterialList(product, identity_id, is_offline);
//   return offlineMaterialList.concat(onlineTakeMaterialList);
// };


const attrList = [
  {
    attr: 0,
    name: '需上传资料',
  },
  {
    attr: 1,
    name: '需邮寄资料',
  },
  {
    attr: 2,
    name: '赴馆携带资料',
  },
];

// 资料分类的list
const materialClassifyList = [
  {
    value: 2,
    label: '个人资料',
    sub: [
      { value: 1, label: '护照首页/护照原件' },
      { value: 2, label: '申根签证页' },
      { value: 3, label: '身份证' },
      { value: 4, label: '户口本' },
      { value: 5, label: '婚姻证明' },
      { value: 6, label: '出生证' },
      { value: 7, label: '居住证' },
      { value: 9, label: '申请表资料' },
      { value: 8, label: '其他' },
    ],
  },
  {
    value: 3,
    label: '社会身份',
    sub: [
      { value: 1, label: '在职人员' },
      { value: 2, label: '学生证明' },
      { value: 3, label: '无业人员' },
      { value: 4, label: '退休人员' },
      { value: 5, label: '学龄前儿童' },
      { value: 6, label: '其他' },
    ],
  },
  {
    value: 4,
    label: '资产资料',
    sub: [
      { value: 1, label: '工资流水 / 银行流水' },
      { value: 2, label: '存款证明' },
      { value: 3, label: '存单' },
      { value: 4, label: '纳税证明' },
      { value: 5, label: '资金证明 * 选一' },
      { value: 6, label: '房产 / 车产' },
      { value: 7, label: '其他' },
    ],
  },
  {
    value: 5,
    label: '行程相关',
    sub: [
      { value: 1, label: '行程单' },
      { value: 2, label: '机票预定单' },
      { value: 3, label: '酒店' },
      { value: 4, label: '保险' },
      { value: 5, label: '其他' },
    ],
  },
  {
    value: 6,
    label: '外方资料',
    sub: [
      { value: 1, label: '邀请证明' },
      { value: 2, label: '事业者登录证明' },
      { value: 3, label: '入学许可证' },
      { value: 4, label: '在留资格证' },
      { value: 5, label: 'CAS' },
      { value: 6, label: 'ATAS' },
      { value: 7, label: '入学通知书' },
      { value: 8, label: '批文' },
      { value: 9, label: '其他' },
    ],
  },
  {
    value: 7,
    label: '生活证明',
    sub: [
      { value: 1, label: '医院体检' },
      { value: 2, label: '黄本疫苗' },
      { value: 3, label: '健康申报表' },
      { value: 4, label: '隔离同意书' },
      { value: 5, label: '无犯罪记录证明' },
      { value: 6, label: '其他' },
    ],
  },
  {
    value: 8,
    label: '同行人资料',
    sub: [],
  },
];

// 生成已分类的资料list, 主要作用是根据attr和资料catalog_id来分类，共三层结构
export const generateClassifiedMaterialList = function (product, identity_id, is_offline) {
  const materialList = generateMaterialList(product, identity_id, is_offline);

  const list = [];
  attrList.forEach((attrItem) => {
    const attrMaterialList = materialList.filter(item => item.attr === attrItem.attr);
    if (attrMaterialList.length) {
      const item = {
        ...attrItem,
        materialTotal: attrMaterialList.length,
        classifyList: [],
      };
      materialClassifyList.forEach((classifyItem) => {
        const currClassifyMaterList = attrMaterialList.filter(item => item.catalog_id === classifyItem.value);
        if (currClassifyMaterList.length) {
          item.classifyList.push({
            catalog_id: classifyItem.value,
            name: classifyItem.label,
            materialList: currClassifyMaterList,
          });
        }
      });
      list.push(item);
    }
  });

  return list;

};

// 评价等级
export const commentLevelMap = {
  1: '好评',
  2: '中评',
  3: '差评',
};



// WEBPACK FOOTER //
// ./src/pages/product/services/material-service.js